
//import { MNField } from "./field";
//import { MetaNode } from "../../Browser/Objects/metanode";

import { html } from "lit";
import { LorbizField } from "./field";
import { BOFragment, SElement } from "../../Browser/Objects/SElement";
import { customElement, query, state } from "lit/decorators.js";
import { unsafeHTML } from 'lit/directives/unsafe-html.js';


const buttonWeakMap = new WeakMap<LorbizField, LorbizButton>();

@customElement("lorbiz-button")
class LorbizButton extends BOFragment {
    btn_callback: boolean = false;
    btn_id: number = 0;
    @state() buttonCaption: string = "";
    @state() iconPayload: string = "";
    @query(".-bt") buttonElement!: HTMLButtonElement;
    constructor(binded: LorbizField) {
        super(binded);
        this.buttonCaption = binded.caption;
        binded.onCaptionChange.subscribe((caption) => { this.buttonCaption = caption; });
    }

    protected override render() {
        const noIcon = !this.iconPayload?.trim();
        return html`
        <button class="-bt" @click="${this.btnClickEvent}">
            <div class="-hld ${noIcon ? "no-icon" : ""}">
                <div class="-btnicon">${unsafeHTML(this.iconPayload)}</div>
                <div class="-btncap">${unsafeHTML(this.buttonCaption)}</div>
            </div>
        </button>
    `;
    }

    //  protected override async firstUpdated() {
    //     await this.updateComplete;

    //     console.log("✅ shadowRoot:", this.shadowRoot?.innerHTML); // should show the <button>
    //     console.log("✅ manual query:", this.shadowRoot?.querySelector('.-bt')); // should be HTMLButtonElement
    //     console.log("✅ @query:", this.buttonElement); // should be same element

    //     // Try focusing
    //     this.buttonElement?.focus();
    // }

    btnClickEvent(e: MouseEvent) {
        if (this.btn_callback) {
            var rndCallback = thisclass.makeid();
            this.pushEvent("callback|" + rndCallback);
            window.open("/btncbak/" + rndCallback, "_blank");
        } else {
            var arg = "x";
            if (e.altKey) arg += "a";
            if (e.ctrlKey) arg += "c";
            if (e.shiftKey) arg += "s";
            if (e.which !== 1) arg += "l";
            this.pushEvent(arg);
        }
    }
}


export var thisclass = {
    button: function (a: { cb: boolean; id: number; }) {
        var field = (window as any).oos(a.id) as LorbizField;
        var buttonFragment = field.appendChild(new LorbizButton(field));
        buttonFragment.btn_callback = a.cb;
        buttonFragment.btn_id = a.id;
        buttonWeakMap.set(field, buttonFragment);
    },

    setcallback: function (id: number, cb: string) {
        var field = (window as any).oos(id) as LorbizField;
        var button = buttonWeakMap.get(field);
        button!.btn_callback = (cb == "1");
    },

    setfocus: function (id: string) {
        // (window as any).afterRender.push(() => {
        //     setTimeout(() => {
        //         var field = (window as any).oos(id) as LorbizField;
        //         var buttonFragment = buttonWeakMap.get(field)!;
        //         (window as any).buttonFragmentElement = buttonFragment;

        //         try {
        //             buttonFragment.buttonElement.focus();
        //         } catch (error) {
        //             console.warn("Error focusing button: on field ",field);
        //         }
        //         // buttonFragment.buttonElement.scrollIntoView({ behavior: "smooth", block: "center" });
        //     }, 100);
        // });
    },

    setbuttonicon: function (id: string, pld: string, hasCaption: boolean) {
        var field = (window as any).oos(id) as LorbizField;
        var btn = buttonWeakMap.get(field)!;
        btn.iconPayload = pld;
    },


    // text: function (id: string, text: string) {
    //     // //if (text === "Compilar") debugger;
    //      var field = (window as any).oos(id) as LorbizField    ;
    //      field.setCaption(text);
    //      var button = buttonWeakMap.get(field)!;
    //     button.innerText = text;
    // },

    makeid: function () {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        for (var i = 0; i < 30; i++) text += possible.charAt(Math.floor(Math.random() * possible.length));
        return text;
    }

}

